import { GroupDataTypes } from '@witkac/kartamiejska-shared';

import defaultSchema from './default.schema';

export default {
  ...defaultSchema,
  title: 'group',
  type: 'object',
  properties: {
    name: {
      type: 'string',
      title: 'Nazwa',
      fieldRequired: true,
      maxLength: 500
    },
    auto: {
      type: 'boolean',
      title: 'Kryteria'
    },
    data: {
      type: 'object',
      properties: {
        type: {
          type: 'number',
          title: 'typ'
        },
        field: {
          type: 'string',
          title: 'pole',
          fieldRequired: `$parent.auto === true`
        },
        number: {
          type: 'number',
          title: 'liczba',
          fieldRequired: `this.type === ${GroupDataTypes.Number}`
        },
        text: {
          type: 'string',
          title: 'tekst'
        },
        array: {
          type: 'array',
          title: 'tablica',
          items: {
            type: 'string'
          },
          minItems: `this.type === ${GroupDataTypes.ArrayIncludes} ? 1 : 0`,
          fieldRequired: `this.type === ${GroupDataTypes.ArrayIncludes}`
        },
        range: {
          type: 'object',
          properties: {
            min: {
              type: 'number',
              fieldRequired: `$parent.type === ${GroupDataTypes.Age} || $parent.type === ${GroupDataTypes.Range}`
            },
            max: {
              type: 'number',
              fieldRequired: `$parent.type === ${GroupDataTypes.Age}  || $parent.type === ${GroupDataTypes.Range}`,
              validFunc: `$parent.type === ${GroupDataTypes.Age} || $parent.type === ${GroupDataTypes.Range} ? $value > this.min : true`
            }
          }
        },
        data: {
          type: 'object',
          properties: {
            woj: {
              title: 'Województwo',
              type: 'string'
            },
            pow: {
              title: 'Powiat',
              type: 'string'
            },
            gmi: {
              title: 'Gmina',
              type: 'string'
            },
            terc: {
              title: 'terc',
              type: 'string'
            },
            city: {
              title: 'Miejscowość',
              type: 'string'
            },
            simc: {
              title: 'Miejscowość',
              type: 'string'
            },
            streets: {
              title: 'Ulice',
              type: 'string'
            },
            ulic: {
              title: 'Ulice',
              type: 'string'
            }
          }
        }
      }
    }
  }
};
